import type { FC } from 'react';
import React from 'react';
import { Box, CircularProgress, Divider, Skeleton, Stack } from '@mui/material';

const WidgetSkeleton: FC = () => (
  <Stack
    direction="column"
    sx={{
      height: '100%',
    }}
  >
    <Stack
      direction="column"
      sx={{
        justifyContent: 'center',
        flexGrow: 1,
      }}
    >
      <Stack
        direction="row"
        sx={{
          justifyContent: 'center',
        }}
      >
        <CircularProgress size={60} />
      </Stack>
    </Stack>
    <Divider />
    <Box
      sx={{
        py: 1,
        px: 1,
      }}
    >
      <Skeleton variant="text" height={62} />
    </Box>
  </Stack>
);

export default WidgetSkeleton;
